import { body2Bold, body2Medium } from 'ui/theme/typography/styles';
import { colors } from 'ui/theme/colors';
import styled from 'styled-components';

export const StyledDT = styled.dt`
    ${body2Bold}
`;

export const StyledDD = styled.dd`
    ${body2Medium}
    color: ${colors.textSecondary};
`;
